import { get, post, put, httpDelete } from 'api/client';
import config from 'config';
import {
  ProfileGroupDetail,
  ProfileGroupsListParams,
  ProfileGroupsListResponse,
  UpsertProfileGroupParams,
} from '../types/profileGroup';

export const ProfileGroupsApi = {
  getList(
    params?: ProfileGroupsListParams,
  ): Promise<ProfileGroupsListResponse> {
    const queryParams = params
      ? Object.fromEntries(
          Object.entries(params).filter(([, value]) => value !== undefined),
        )
      : undefined;

    return get('/profile-groups', {
      params: queryParams,
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  getDetail(profileGroupId: number): Promise<ProfileGroupDetail> {
    return get(`/profile-groups/${profileGroupId}`, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  create(data: UpsertProfileGroupParams): Promise<ProfileGroupDetail> {
    return post('/profile-groups', data, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  update(
    profileGroupId: number,
    data: UpsertProfileGroupParams,
  ): Promise<ProfileGroupDetail> {
    return put(`/profile-groups/${profileGroupId}`, data, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  delete(profileGroupId: number): Promise<void> {
    return httpDelete(`/profile-groups/${profileGroupId}`, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  leave(profileGroupId: number): Promise<void> {
    return httpDelete(`/profile-groups/${profileGroupId}/users/me`, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  uploadLogo(profileGroupId: number, file: File): Promise<ProfileGroupDetail> {
    const data = new FormData();
    data.append('logo', file);
    return post(`/profile-groups/${profileGroupId}/logo`, data, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  removeLogo(profileGroupId: number): Promise<ProfileGroupDetail> {
    return httpDelete(`/profile-groups/${profileGroupId}/logo`, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },
};
